import React from 'react';
import Lozenge, { ThemeAppearance } from '@atlaskit/lozenge';
import { Box, Flex } from '@atlaskit/primitives';

export const BillingProfileLozenge = ({
  appearance,
  label,
}: {
  appearance: ThemeAppearance | undefined;
  label: string;
}) => {
  return (
    <Box paddingInlineStart="space.050">
      <Flex alignItems="center">
        <Lozenge appearance={appearance}>{label}</Lozenge>
      </Flex>
    </Box>
  );
};
